import i18next from 'i18next';
import AllergiEndResources from '../../../../../components/AllergiEndResources/AllergiEndResources';
import AllergiEndResourcesLogo
  from '../../../../../components/Shared/Icons/AllergiEndResourcesLogo';
import permissions from '../../../../permissions';

const ALLERGI_END_RESOURCES_DASHBOARD = {
    path: 'allergi-end-resources',
    exact: true,
    additional: {
      component: AllergiEndResources,
      protected: true,
      title: i18next.t('titles:allergiEndResources'),
      icon: AllergiEndResourcesLogo,
      permission: permissions.ACCOUNT_GET_ALLERGIEND_RESOURCES,
    },
};
export const ALLERGI_END_RESOURCES_ROUTES = {
  // ------- For child accounts ------
  // ...

  // ------- For current accounts ------
  dashboard: ALLERGI_END_RESOURCES_DASHBOARD,
};
